import type { Exposure } from "@amplitude/experiment-js-client"

import { Analytics } from "@bounce/analytics"
import Datadog from "@bounce/datadog"

export const trackedExperiments = new Set<string>()

/**
 * Only expose variant once by session, calls
 * - Analytics.track
 * - Datadog.addFeatureFlagEvaluation
 */
export const exposeOnce = (exposure: Exposure) => {
  const experimentVariant = `${exposure.experiment_key}/${exposure.flag_key}/${exposure.variant}`
  const hasTracked = trackedExperiments.has(experimentVariant)

  if (hasTracked) return

  Analytics.track("$exposure", exposure)
  void Datadog.addFeatureFlagEvaluation(exposure.flag_key, exposure.variant)
  trackedExperiments.add(experimentVariant)
}

/**
 * Reset the exposure memory used to track exposure once
 */
export const clearExposureMemory = () => {
  trackedExperiments.clear()
}
